import { useEffect, useState } from 'react';
import api from '../../api/axios';
import { createDiscount, updateDiscount } from '../../api/discounts.api';

export default function DiscountFormModal({ onClose, onSaved, data }) {
  const [form, setForm] = useState({
    code: data?.code || '',
    type: data?.type || 'percent',
    value: data?.value || '',
    global: data?.global ?? true,
    product: data?.product || '',
    expiresAt: data?.expiresAt ? new Date(new Date(data.expiresAt).getTime() - new Date(data.expiresAt).getTimezoneOffset() * 60000).toISOString().slice(0, 16) : '',
    currency: data?.currency || 'IRR',
  });

  const isEdit = !!data;

  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get('/productlist').then(({ data }) => setProducts(data)).catch(() => setError('دریافت محصولات انجام نشد؛ فرم را دوباره باز کنید.'));
  }, []);
  const submit = async (e) => {
    e.preventDefault();
    if (saving) return;
    setSaving(true);
    setError('');
    try {
      const payload = { ...form, code: form.code.trim().toUpperCase(), value: Number(form.value),
        product: form.global ? null : form.product,
        expiresAt: form.expiresAt ? new Date(form.expiresAt).toISOString() : null };
      if (isEdit) await updateDiscount(data._id, payload);
      else await createDiscount(payload);
      onSaved();
    } catch (err) {
      setError(err.response?.data?.error || 'ذخیره انجام نشد؛ دوباره تلاش کنید.');
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center">
      <form
        onSubmit={submit}
        className="bg-white w-full max-w-md p-6 rounded-2xl shadow-xl">
        <h2 className="font-bold text-lg mb-4">
          {isEdit ? 'ویرایش کد تخفیف' : 'ایجاد کد جدید'}
        </h2>

        <div className="space-y-3">
          <input
            type="text"
            className="w-full border p-2 rounded-xl"
            placeholder="کد"
            value={form.code}
            onChange={(e) => setForm({ ...form, code: e.target.value })}
            required
          />

          <select
            className="w-full border p-2 rounded-xl"
            value={form.type}
            onChange={(e) => setForm({ ...form, type: e.target.value })}>
            <option value="percent">درصدی</option>
            <option value="amount">مبلغ ثابت</option>
          </select>

          <input
            type="number"
            className="w-full border p-2 rounded-xl"
            placeholder="مقدار"
            min={form.type === 'amount' && form.currency === 'IRR' ? 1 : 0.01}
            max={form.type === 'percent' ? 99.99 : undefined}
            step={form.type === 'amount' && form.currency === 'IRR' ? 1 : 0.01}
            value={form.value}
            onChange={(e) => setForm({ ...form, value: e.target.value })}
            required
          />

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={form.global}
              onChange={(e) => setForm({ ...form, global: e.target.checked })}
            />
            اعمال برای تمام محصولات؟
          </label>

          {form.type === 'amount' && <label className="block text-sm">واحد مبلغ ثابت
            <select className="w-full border p-2 rounded-xl" value={form.currency} onChange={e => setForm({ ...form, currency: e.target.value })}>
              <option value="IRR">تومان — پرداخت ایران</option>
              <option value="EUR">یورو — پرداخت خارج از ایران</option>
            </select>
          </label>}
          {!form.global && <select required className="w-full border p-2 rounded-xl" value={form.product} onChange={e => setForm({ ...form, product: e.target.value })}>
            <option value="">انتخاب محصول</option>
            {products.map(p => <option key={p._id} value={p.name.code}>{p.name.displayName || p.name.code}</option>)}
          </select>}
          <label className="block text-sm">زمان انقضا به وقت دستگاه؛ خالی یعنی بدون انقضا</label>

          <input
            type="datetime-local"
            className="w-full border p-2 rounded-xl"
            value={form.expiresAt}
            onChange={(e) => setForm({ ...form, expiresAt: e.target.value })}
          />
        </div>

        {data?.maxUses != null && <p className="text-amber-700 text-sm">این کد سقف مصرف دارد و فعلاً در پرداخت آنلاین قابل استفاده نیست؛ یک کد جدید بدون سقف بسازید.</p>}
        {error && <p role="alert" className="mt-3 text-red-600">{error}</p>}
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            disabled={saving}
            onClick={onClose}
            className="px-4 py-2 rounded-xl border">
            بستن
          </button>

          <button
            type="submit"
            disabled={saving}
            className="px-4 py-2 rounded-xl bg-blue-600 text-white">
            {saving ? 'در حال ذخیره…' : 'ذخیره'}
          </button>
        </div>
      </form>
    </div>
  );
}
